import React from "react";
import EditIcon from "@material-ui/icons/Edit";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import ViewQuiltOutlinedIcon from "@material-ui/icons/ViewQuiltOutlined";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import PublishIcon from "@material-ui/icons/Publish";
import { FlyerDetailPageEditType } from "../../../../types/flyer-detail-page-state/flyer-detail-page-state.interface";
import cx from "classnames";
import { FlyerDetailPageDetailSideMenuProps } from "./flyer-detail-page-detail-side-menu.props";
import { HostContainer } from "./flyer-detail-page-detail-side-menu.styles";
import { withShowIf } from "../../../../../../../../../../components/with-show-if/with-show-If.component";
import { FlyerDetailPageDetailSideMenuIcon } from "../flyer-detail-page-detail-side-menu-icon/flyer-detail-page-detail-side-menu-icon.component";

export const FlyerDetailPageDetailSideMenu = withShowIf(
  (props: FlyerDetailPageDetailSideMenuProps) => {
    const getClassName = (type: FlyerDetailPageEditType) => cx({ active: props.editType === type });

    const select = (type: FlyerDetailPageEditType) => () => props.onClick(type);

    const PageEditIcon = () => (props.hasPageDetails ? <EditIcon /> : <EditOutlinedIcon />);
    const getPageEditIconVariant = () => (props.hasPageDetails ? "filled" : "hollow");

    return (
      <HostContainer>
        <FlyerDetailPageDetailSideMenuIcon
          tooltip="Edit Page"
          onClick={select("page")}
          className={getClassName("page")}
          variant={getPageEditIconVariant()}
        >
          {PageEditIcon()}
        </FlyerDetailPageDetailSideMenuIcon>

        <FlyerDetailPageDetailSideMenuIcon
          tooltip="Assets"
          onClick={select("assets")}
          className={getClassName("assets")}
          variant="filled"
        >
          <PublishIcon />
        </FlyerDetailPageDetailSideMenuIcon>

        <FlyerDetailPageDetailSideMenuIcon
          tooltip="Edit Position"
          onClick={select("position")}
          className={getClassName("position")}
          variant="filled"
        >
          <ViewQuiltOutlinedIcon />
        </FlyerDetailPageDetailSideMenuIcon>

        <FlyerDetailPageDetailSideMenuIcon
          tooltip="Comments"
          onClick={select("comments")}
          className={getClassName("comments")}
          variant="filled"
        >
          <QuestionAnswerIcon />
        </FlyerDetailPageDetailSideMenuIcon>
      </HostContainer>
    );
  }
);
